












import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import JobsDataTable from "../../components/DataTables/JobsDataTable.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as temp from "../../_store/temp.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import NoPage from "../../components/Error/NoPage.vue";

import * as data from "../../_store/data.module";

@Component({
    components: {
        CardTitle,
        JobsDataTable,
        NoPage
    }
})
export default class Proposte extends Vue {
    private titleParams: object;
    private dataTableParams: any;
    private createDialogParams: object;
    private candidatureDialogParams: object;

    private listaProposte: any;

    constructor() {
        super();
        this.titleParams = {
            title: "Proposte Lavorative",
            cols: "10",
            sm: "5",
            md: "5",
            lg: "4"
        };
        this.dataTableParams = {
            headers: [
                {
                    text: "Offerta",
                    value: "nomeProposta"
                },
                {
                    text: "Azienda",
                    value: "denominazioneAzienda"
                },
                {
                    text: "Settore",
                    value: "nomeArticolazione"
                },
                {
                    text: "Ruolo",
                    value: "ruolo"
                },
                {
                    text: "Tipo Contratto",
                    value: "tipoContratto"
                },
                {
                    text: "Sede Lavoro",
                    value: "sede"
                },
                {
                    text: "Data Creazione",
                    value: "dataCreazione"
                },
                {
                    text: "Dettagli Offerta",
                    value: "dettagliOfferta",
                    sortable: false,
                    width: "1%"
                },
                {
                    text: "Candidature",
                    value: "candidatureProposteLavoro",
                    sortable: false,
                    width: "1%"
                },
                // {
                //   text: "Mofica Offerta",
                //   value: "modificaOfferta",
                //   sortable: false,
                //   width: "1%"
                // },
            ],
            records: [],
            dialogParams: {
                title: "DETTAGLI PROPOSTA",
                type: "jobOffer"
            },
            filterType: "listaOfferteIstituto",
            listaArticolazioni: [
                {
                    idArticolazione: "Tutte",
                    nomeArticolazione: "Tutti"
                }
            ]
        };
        this.candidatureDialogParams = {
            headers: [
                {
                    text: "Allievo",
                    value: "allievo"
                },
                {
                    text: 'Telefono',
                    value: 'telefono'
                },
                {
                    text: "Data Candidatura",
                    value: "dataCandidatura"
                },
                {
                    text: "Curriculum Vitae",
                    value: "curriculum",
                    width: "1%"
                },
                {
                    text: "Colloquio Avvenuto",
                    value: "colloquioAvvenutoIstituto",
                    width: "1%"
                }
            ],
            records: []
        };
        this.createDialogParams = {
            visible: true,
            type: "proposteLavoroIstituto"
        };
        this.listaProposte = [];
    }

    loadProposte() {
        var instituteInfo = user.readInstituteInfo(this["$store"]);
        var payload = {
            idIstituto: instituteInfo.id
        };
        data
            .dispatchListaProposteLavoroIstituto(this["$store"], payload)
            .then(result => {
                this.dataTableParams.records = result;
                this.listaProposte = result;
                bus.$emit("dataLoaded");
            })
            .catch(error => {
                if (error.response.status === 403) {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                    this["$router"].push("/login");
                } else {
                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                }
            });
    }

    created() {
        var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
        var token = localStorage.getItem("userToken");
        var parsedToken: any;
        if (token !== null) {
            parsedToken = userUtils.parseToken(token);
        }
        var payload = {
            idUtente: parsedToken.IdUtente,
            tipoSoggetto: parsedToken.IdTipoSoggetto,
            username: parsedToken.Username
        };
        user
            .dispatchSetUserInfo(this["$store"], payload)
            .then(() => {
                user
                    .dispatchSetInstituteInfo(this["$store"])
                    .then(() => {
                        var instituteInfo = user.readInstituteInfo(this["$store"])
                        data
                            .dispatchArticolazioni(this["$store"], instituteInfo.id)
                            .then(response => {
                                response.forEach(element => {
                                    this.dataTableParams.listaArticolazioni.push(element);
                                });
                                bus.$emit("loadMenu");
                                this.loadProposte();
                            })
                            .catch(error => {
                                if (error.response.status === 403) {
                                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                                    this["$router"].push("/login");
                                } else {
                                    bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
                                }
                            });
                    })
                    .catch(() => {
                        bus.$emit("stopLoading");
                        auth.dispatchLogout(this["$store"]);
                        user.dispatchClearState(this["$store"]);
                        this["$router"].push("/sessionExpired");
                    });
            })
            .catch(() => {
                bus.$emit("stopLoading");
                auth.dispatchLogout(this["$store"]);
                user.dispatchClearState(this["$store"]);
                this["$router"].push("/sessionExpired");
            });

        bus.$on("loadProposte", () => {
            this.loadProposte();
        });

        bus.$on("filtroOfferteIstituto", (filters: any) => {
            const listaOfferte: any = this.listaProposte;
            var tempList: any = [];
            this.dataTableParams.records = [];
            listaOfferte.forEach((item: any) => {
                if (filters.fitroArticolazione !== "Tutte") {
                    if (filters.fitroArticolazione === "IT01") {
                        if (item.idArticolazione === "IT01") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "IT04") {
                        if (item.idArticolazione === "IT04") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "IT05") {
                        if (item.idArticolazione === "IT05") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "IT10") {
                        if (item.idArticolazione === "IT10") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "IT13") {
                        if (item.idArticolazione === "IT13") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "ITAF") {
                        if (item.idArticolazione === "ITAF") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "ITEN") {
                        if (item.idArticolazione === "ITEN") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "ITET") {
                        if (item.idArticolazione === "ITET") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "ITIA") {
                        if (item.idArticolazione === "ITIA") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "ITMM") {
                        if (item.idArticolazione === "ITMM") {
                            tempList.push(item);
                        }
                    }
                    if (filters.fitroArticolazione === "LI03") {
                        if (item.idArticolazione === "LI03") {
                            tempList.push(item);
                        }
                    }
                } else {
                    tempList.push(item);
                }
            });
            this.dataTableParams.records = tempList;
        });
    }
}
